import { useSelector } from "react-redux";
import clsx from "clsx";

import { Link } from "react-router-dom";

import SectionContent from "../../../components/sectionContent/sectionContent";
import Settings from "../../../pages/tunder/settings/settings";
import Sidebar from "../../../components/sidebar/Sidebar";

import "../../../scss/App.scss";
import { IUserOptions } from "../../../types/interfaces";

const SettingsApp = () => {
  const { claims } = useSelector((state: IUserOptions) => state.user.user.data);
  const { isOpenSidebar } = useSelector(
    (state: IUserOptions) => state.user.user
  );

  return (
    <div className="App">
      <Sidebar />
      <SectionContent section="Тандер" title="Настройки">
        <div className="content__main">
          <div
            className={clsx(
              isOpenSidebar && "btns_active",
              !isOpenSidebar && "btns_close",
              "btns"
            )}
          >
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/shops" className="tab">
                <div className="buttons__btn">Торговые точки</div>
              </Link>
            )}
            {(claims.includes("admin") || claims.includes("tander:view")) && (
              <Link to="/tunder/signals" className="tab">
                <div className="buttons__btn">Сигналы</div>
              </Link>
            )}
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/properties" className="tab">
                <div className="buttons__btn --active">Настройки</div>
              </Link>
            )}
            <Link to="/tunder/goods" className="tab">
              <div className="buttons__btn">Товары</div>
            </Link>
            {(claims.includes("admin") ||
              claims.includes("tander:settings")) && (
              <Link to="/tunder/access" className="tab">
                <div className="buttons__btn">Доступы</div>
              </Link>
            )}
          </div>
          <Settings />
        </div>
      </SectionContent>
    </div>
  );
};

export default SettingsApp;
